import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, updateDoc, getDoc } from 'firebase/firestore';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(4),
        width: '100%',
        maxWidth: '400px',
        boxShadow: theme.shadows[5],
    },
    title: {
        marginBottom: theme.spacing(3),
        fontWeight: 600,
    },
    inputField: {
        marginBottom: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.5),
        fontSize: '16px',
    },
    errorMessage: {
        marginTop: theme.spacing(2),
        color: theme.palette.error.main,
        textAlign: 'center',
    },
}));


///////////////////////////////////////////////

const RoleSelection = function() {
    const { t } = useTranslation();
    const classes = useStyles();
    const [role, setRole] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation(); // ⬅️ NEW
    const params = new URLSearchParams(location.search); // ⬅️ NEW

    useEffect(function() {
        const checkUserRole = async function() {
            const auth = getAuth();
            const db = getFirestore();
            if (auth.currentUser) {
                const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
                if (userDoc.exists()) {
                    const roleFromFirestore = userDoc.data().role;
                    if (roleFromFirestore) {
                        localStorage.setItem('selectedRole', roleFromFirestore);
                        navigate('/' + roleFromFirestore.toLowerCase() + '/dashboard');
                    }
                }
            }
        };
        checkUserRole();
    }, [navigate]);

    const handleRoleChange = (event) => {
        setRole(event.target.value);
    };

    const handleSubmit = async () => {
        if (!role) {
            setError(t('form_incomplete'));
            return;
        }

        const auth = getAuth();
        const db = getFirestore();
        if (!auth.currentUser) {
            setError(t('user_not_authenticated'));
            return;
        }

        try {
            const userDocRef = doc(db, 'users', auth.currentUser.uid);
            await updateDoc(userDocRef, { role });
            localStorage.setItem('selectedRole', role);

            // --- ⬇️ Redirect Logic Starts Here ---
            let destination = params.get('redirect') || `/${role.toLowerCase()}/dashboard`;
            const assessment = params.get('assessment');
            if (assessment) {
                const url = new URL(window.location.origin + destination);
                url.searchParams.set('assessment', assessment);
                destination = url.pathname + url.search;
            }
            navigate(destination);
            // --- ⬆️ Redirect Logic Ends Here ---
        } catch (error) {
            console.error('Error updating role:', error);
            setError(t('api_error'));
        }
    };


    ////////////////////////////////////

    return _jsxs(Container, {
        className: classes.container,
        children: [
            _jsx(Paper, {
                className: classes.paper,
                children: _jsxs('div', {
                    children: [
                        _jsx(Typography, {
                            variant: 'h4',
                            className: classes.title,
                            align: 'center',
                            children: t('select_role')
                        }),
                        _jsx(TextField, {
                            select: true,
                            fullWidth: true,
                            value: role,
                            onChange: handleRoleChange,
                            label: t('role'),
                            variant: 'outlined',
                            className: classes.inputField,
                            children: [
                                _jsx(MenuItem, {
                                    value: 'Buyer',
                                    children: t('buyer')
                                }),
                                _jsx(MenuItem, {
                                    value: 'Seller',
                                    children: t('seller')
                                }),
                                _jsx(MenuItem, {
                                    value: 'Checkpoint',
                                    children: t('checkpoint')
                                })
                            ]
                        }),
                        _jsx(Button, {
                            onClick: handleSubmit,
                            variant: 'contained',
                            color: 'primary',
                            fullWidth: true,
                            className: classes.button,
                            children: t('submit')
                        }),
                        error && _jsx(Typography, {
                            variant: 'body2',
                            className: classes.errorMessage,
                            children: error
                        })
                    ]
                })
            })
        ]
    });
};

export default RoleSelection;
